<template>
  <div>
  <!-- <div class="app-container"> -->
 <!-- <div style="background-color: rgb(255, 255, 255); position: relative; height: calc(100% + 0px); width: 100%; padding: 20px;"> -->
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="false" v-show="showSearch" label-width="168px">

<el-form-item label="上传「营业执照」" prop="appIds">
        <!-- <el-input
          v-model="queryParams.appIds"
          placeholder="请输入附件"
          clearable
          @keyup.enter.native="handleQuery"
        /> -->

        <br/>
   <el-upload 
  class="upload-demo"
  drag
  action="https://jsonplaceholder.typicode.com/posts/"
  multiple>
  <i class="el-icon-upload" ></i>
  <div class="el-upload__text">
    将文件拖到此处，或<em>点击上传</em><br>
  <!-- <span class="el-upload__text" >必须为清晰、完整的彩色原件扫描件、数码照，或者电子营业执照</span> -->
  必须为清晰、完整的彩色原件扫描件、数码照，或者电子营业执照
<!-- <br><span class="el-upload__text" style="color: rgba(0,0,0,1);font-size: 16px;font-family: AlibabaPuHui;font-weight: 400;line-height: 23px;">仅支持 png、jpg、bmp的图片格式，图片大小上限4M</span>   -->
<br>仅支持 png、jpg、bmp的图片格式，图片大小上限4M
</div>
  <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
</el-upload>
      </el-form-item>
      

      <!-- <el-row>
<el-col :span="12">
 <el-form-item label="主键" prop="pid">
        <el-input
          v-model="queryParams.pid"
          placeholder="请输入主键"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>

</el-col>
<el-col :span="12">
  <el-form-item label="租户" prop="tenantId">
        <el-input
          v-model="queryParams.tenantId"
          placeholder="请输入租户"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
</el-col>

      </el-row> -->
     
            <el-row>
<el-col :span="12">
      <el-form-item label="公司名称" prop="companyName">
        <el-input
          v-model="queryParams.companyName"
          placeholder="请输入公司名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="统一社会信用代码" prop="unifiedSocialCreditIdentifier">
        <el-input
          v-model="queryParams.unifiedSocialCreditIdentifier"
          placeholder="请输入统一社会信用代码"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      </el-col>
      </el-row>
            <el-row>
<el-col :span="12">
      <el-form-item label="法定代表人" prop="legalRepresentative">
        <el-input
          v-model="queryParams.legalRepresentative"
          placeholder="请输入法定代表人"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      </el-col>
      <el-col :span="12">
      <el-form-item label="成立时间" prop="dateEstablishment">
        <el-date-picker clearable
          v-model="queryParams.dateEstablishment"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择成立时间">
        </el-date-picker>
      </el-form-item>
      </el-col>
      </el-row>
            <el-row>
<el-col :span="12">
      <el-form-item label="营业期限" prop="businessTerm">
        <el-input
          v-model="queryParams.businessTerm"
          placeholder="请输入营业期限"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      </el-col>
      <el-col :span="12">
      <el-form-item label="注册资本(万元)" prop="registeredCapital">
        <el-input
          v-model="queryParams.registeredCapital"
          placeholder="请输入注册资本(万元)"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      </el-col>
      </el-row>

            <el-row>
<el-col :span="12">

      <el-form-item label="注册地址" prop="registeredAddress">
        <el-input
          v-model="queryParams.registeredAddress"
          placeholder="请输入注册地址"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      </el-col>
      <el-col :span="12">
          <el-form-item label="企业类型" prop="类型">
        <el-input
          v-model="queryParams.enterpriseType"
          placeholder="企业类型"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      </el-col>
      </el-row>
      <!-- <el-form-item label="附件" prop="appIds">
        <el-input
          v-model="queryParams.appIds"
          placeholder="请输入附件"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item> -->
      <el-form-item label="经营范围" prop="version">
        <el-input
          v-model="queryParams.version"
          placeholder="经营范围"
            type="textarea"
          :rows="3"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <!-- <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button> -->

          <!-- <el-button type="info" plain>取消</el-button>
          <el-button type="primary">保存</el-button> -->
          <div class="el-dialog__footer">
            <div class="dialog-footer">
              <button type="button" class="el-button el-button--primary el-button--medium" @click="editinfo"><!----><!----><span>{{stateinfo}}</span></button>
              <button type="button" class="el-button el-button--default el-button--medium"><!----><!----><span>取 消</span></button>
            </div></div>

      </el-form-item>
    </el-form>


<!-- 
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          v-hasPermi="['creditlibrary:enterpriseinfo:add']"
        >新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="success"
          plain
          icon="el-icon-edit"
          size="mini"
          :disabled="single"
          @click="handleUpdate"
          v-hasPermi="['creditlibrary:enterpriseinfo:edit']"
        >修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="danger"
          plain
          icon="el-icon-delete"
          size="mini"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['creditlibrary:enterpriseinfo:remove']"
        >删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="warning"
          plain
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
          v-hasPermi="['creditlibrary:enterpriseinfo:export']"
        >导出</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row> -->


    <!-- <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    /> -->

    <!-- 添加或修改企业信息对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="主键" prop="pid">
          <el-input v-model="form.pid" placeholder="请输入主键" />
        </el-form-item>
        <el-form-item label="租户" prop="tenantId">
          <el-input v-model="form.tenantId" placeholder="请输入租户" />
        </el-form-item>
        <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="form.companyName" placeholder="请输入公司名称" />
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="unifiedSocialCreditIdentifier">
          <el-input v-model="form.unifiedSocialCreditIdentifier" placeholder="请输入统一社会信用代码" />
        </el-form-item>
        <el-form-item label="法定代表人" prop="legalRepresentative">
          <el-input v-model="form.legalRepresentative" placeholder="请输入法定代表人" />
        </el-form-item>
        <el-form-item label="成立时间" prop="dateEstablishment">
          <el-date-picker clearable
            v-model="form.dateEstablishment"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择成立时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="营业期限" prop="businessTerm">
          <el-input v-model="form.businessTerm" placeholder="请输入营业期限" />
        </el-form-item>
        <el-form-item label="注册资本(万元)" prop="registeredCapital">
          <el-input v-model="form.registeredCapital" placeholder="请输入注册资本(万元)" />
        </el-form-item>
        <el-form-item label="注册地址" prop="registeredAddress">
          <el-input v-model="form.registeredAddress" placeholder="请输入注册地址" />
        </el-form-item>
        <el-form-item label="经营范围" prop="natureBusiness">
          <el-input v-model="form.natureBusiness" type="textarea" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="附件" prop="appIds">
          <el-input v-model="form.appIds" placeholder="请输入附件" />
        </el-form-item>
        <el-form-item label="版本" prop="version">
          <el-input v-model="form.version" placeholder="请输入版本" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  <!-- </div> -->
  <!-- </div> -->
   </div>
</template>

<script>
import { listEnterpriseinfo, getEnterpriseinfo, delEnterpriseinfo, addEnterpriseinfo, updateEnterpriseinfo } from "@/api/creditlibrary/enterpriseinfo";

export default {
  name: "Enterpriseinfo",
  data() {
    return {
      // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 企业信息表格数据
      enterpriseinfoList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pid: null,
        tenantId: null,
        companyName: null,
        unifiedSocialCreditIdentifier: null,
        legalRepresentative: null,
        enterpriseType: null,
        dateEstablishment: null,
        businessTerm: null,
        registeredCapital: null,
        registeredAddress: null,
        natureBusiness: null,
        appIds: null,
        version: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      },
      stateinfo:"添加"
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询企业信息列表 */
    getList() {
      this.loading = true;
      listEnterpriseinfo(this.queryParams).then(response => {
        this.enterpriseinfoList = response.rows;
        this.total = response.total;
        this.loading = false;

        if (response.total>0) {
          
          this.queryParams=response.rows[0];
          this.stateinfo="修改"
          
        }else{
          this.stateinfo="添加"

        }
      });
    },


//  编辑本网页信息    新增或者修改

editinfo(){
if ( this.stateinfo=="修改") {
      this.loading = true;
  updateEnterpriseinfo(this.queryParams).then(response => {
        // this.enterpriseinfoList = response.rows;
        // this.total = response.total;
        this.loading = false;
        if (response.code=200) {
           this.$message.success('修改成功!')
          
        }


  })
} else {
    this.loading = true;
  addEnterpriseinfo(this.queryParams).then(response => {
        // this.enterpriseinfoList = response.rows;
        // this.total = response.total;
        this.loading = false;
           if (response.code=200) {
           this.$message.success('添加成功!')
          
        }
  })
}

},


    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        pid: null,
        tenantId: null,
        companyName: null,
        unifiedSocialCreditIdentifier: null,
        legalRepresentative: null,
        enterpriseType: null,
        dateEstablishment: null,
        businessTerm: null,
        registeredCapital: null,
        registeredAddress: null,
        natureBusiness: null,
        appIds: null,
        version: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.pid)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加企业信息";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const pid = row.pid || this.ids
      getEnterpriseinfo(pid).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改企业信息";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.pid != null) {
            updateEnterpriseinfo(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addEnterpriseinfo(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const pids = row.pid || this.ids;
      this.$modal.confirm('是否确认删除企业信息编号为"' + pids + '"的数据项？').then(function() {
        return delEnterpriseinfo(pids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('creditlibrary/enterpriseinfo/export', {
        ...this.queryParams
      }, `enterpriseinfo_${new Date().getTime()}.xlsx`)
    }
  }
};
</script>
<style scoped >
/* .app-container {
padding: 20px;
    position: absolute;
    height: 100%;
    width: 100%;
} */
::v-deep .el-upload {
  width: 100%;
}
::v-deep .el-upload-dragger {
  width: 100%;
  height: auto; /* 可根据需求调整高度 */
}
/* ::v-deep .el-icon-upload{
  background-image: url("../../../assets/images/15.jpg");
} */

 ::v-deep .el-upload-dragger .el-icon-upload {
    /* font-size: 112px; */
    color: #C0C4CC;
    /* margin: 40px 0 16px; */
    /* margin: unset; */
    line-height: 99px;
    width: 120px;
    height: 99px;
}
::v-deep .el-icon-upload:before {

  /* 使用其他字体图标编码 */
  content: "\e6d9"; 
  /* 修改图标颜色 */
  /* color: #ff6700;  */
    /* background-image: url("../../../assets/images/login-background.jpg"); */

/* content: unset; */

    /* background-image: url("../../../assets/images/15.jpg"); */
    background-image: url("../../../assets/images/upload.png");

     background-size: cover;
    height: 100%;
    width: 100%;
    display: block;

}


</style>
